const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

class JobApplicationService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async getAll(filters = {}) {
    const queryParams = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        queryParams.append(key, value);
      }
    });

    const queryString = queryParams.toString();
    const endpoint = `/job-applications${queryString ? `?${queryString}` : ''}`;
    
    return this.request(endpoint);
  }

  async getById(id) {
    return this.request(`/job-applications/${id}`);
  }

  async create(applicationData) {
    return this.request('/job-applications', {
      method: 'POST',
      body: JSON.stringify(applicationData),
    });
  }

  async update(id, applicationData) {
    return this.request(`/job-applications/${id}`, {
      method: 'PUT',
      body: JSON.stringify(applicationData),
    });
  }

  async delete(id) {
    return this.request(`/job-applications/${id}`, {
      method: 'DELETE',
    });
  }

  async getAnalytics() {
    return this.request('/job-applications/analytics/data');
  }

  async getFollowUps() {
    return this.request('/job-applications/follow-ups/list');
  }
}

export const jobApplicationService = new JobApplicationService();